import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Divider from '@material-ui/core/Divider';
import KwhNowStatsTotalSpeedo from "../PowerStatsTotalGaugeSet/kwh/KwhNowStatsTotalSpeedo";
import KwhTodayStatsTotalSpeedo from "../PowerStatsTotalGaugeSet/kwh/KwhTodayStatsTotalSpeedo"
import KwhWeekStatsTotalSpeedo from "../PowerStatsTotalGaugeSet/kwh/KwhWeekStatsTotalSpeedo";
import KwhMonthStatsTotalSpeedo from "../PowerStatsTotalGaugeSet/kwh/KwhMonthStatsTotalSpeedo";
import KWHTotalChartSet from "../PowerStatTotalCharts/KWHTotalChartSet";

// style sheet imported locally // 
import styles from '../../../../../assets/widgets/widgetStyles/commonStyles'

const useStyles = makeStyles(styles);

export const KWHPowerStatsTotalSet = (props) => {
  const classes = useStyles();
  return (
    <div>
     <Grid container spacing={0} className={classes.powerStatsTablayout}>
       <Divider variant="fullWidth" className={classes.powerStatsTabDivider} />
       <Grid items md={3}  className={classes.PowerStatsTabHeaderText}>
           {props.language.now}
           <KwhNowStatsTotalSpeedo 
           powerData={props.powerData} 
           powerStatTotal={props.powerStatTotal}
           data={props.data} 
           widget={props.widget}
           language={props.language} />
        </Grid>
       <Grid items md={3}  className={classes.PowerStatsTabHeaderText}>
           {props.language.today}
           <KwhTodayStatsTotalSpeedo 
           powerData={props.powerData} 
           powerStatTotal={props.powerStatTotal}
           data={props.data} 
           widget={props.widget} 
           language={props.language} />
           </Grid>
       <Grid items md={3} className={classes.PowerStatsTabHeaderText}>
           {props.language.thisWeek}
           <KwhWeekStatsTotalSpeedo 
           powerData={props.powerData} 
           powerStatTotal={props.powerStatTotal}
           data={props.data} 
           widget={props.widget}
           language={props.language} />
           </Grid>
       <Grid items md={3}  className={classes.PowerStatsTabHeaderText}>
       {props.language.thisMonth}
       <KwhMonthStatsTotalSpeedo 
       powerData={props.powerData} 
       powerStatTotal={props.powerStatTotal}
       data={props.data} 
       widget={props.widget}
       language={props.language}  />
       </Grid>

       <Grid items md={12}>
       <KWHTotalChartSet 
       widget={props.widget}
       powerData={props.powerData}
       powerStatTotal={props.powerStatTotal}
       totalPowerDataCharts={props.totalPowerDataCharts}
        data={props.data} 
        language={props.language}  />
       </Grid>

      </Grid>
      
    </div>
  );
};

export default KWHPowerStatsTotalSet;